export default "__VITE_ASSET__D4iSM6Qv__"